import React from 'react';
import SectionCard from './SectionCard';
import ScurveChart, { type ProjectScurveRow } from './ScurveChart';
import { Link } from 'react-router-dom';

export default function ScurvePanel({
    rows,
    mode = 'cum',
    linkTo,
}: {
    rows: ProjectScurveRow[];
    mode?: 'cum' | 'cum+inc';
    linkTo?: string;
}) {
    const hasRows = rows.length > 0;

    return (
        <SectionCard
            title="S-Curve"
            right={
                <Link
                    className="shrink-0 inline-flex items-center gap-2 rounded-xl border bg-white px-3 py-1.5 text-xs font-medium text-gray-600 hover:bg-gray-50"
                    to={linkTo ?? ''}
                >
                    상세보기
                    <span aria-hidden className="text-gray-400">
                        →
                    </span>
                </Link>
            }
        >
            {hasRows ? (
                <>
                    <ScurveChart rows={rows} height={380} showIncrementInTooltip={mode === 'cum+inc'} />
                    <div className="mt-2 text-xs text-gray-500">X축은 W1..Wn, Hover 시 날짜(YYYY-MM-DD) 표시</div>
                </>
            ) : (
                <div className="rounded-xl border border-dashed border-slate-200 bg-slate-50 px-4 py-10 text-center text-sm text-slate-500">
                    아직 분석할 WBS가 없습니다. WBS를 먼저 입력하세요.
                </div>
            )}
        </SectionCard>
    );
}
